module.exports = __webpack_public_path__ + "img/9788956608518.1d12330c.jpg";